"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceCurrentUrl = void 0;
const replaceCurrentUrl = url => window.history.replaceState({}, '', url);
exports.replaceCurrentUrl = replaceCurrentUrl;
